import { useRef, useCallback } from "react";
import { Html } from "@react-three/drei";

// Component for random color generation
const useRandomColor = () => {
  const randomColor = useCallback(() => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }, []);
  return randomColor;
};

// CarouselIndicator Component
const CarouselIndicator = ({ index, isActive }) => (
  <li
    data-target="#carouselExampleIndicators"
    data-slide-to={index}
    className={isActive ? "active" : ""}
  ></li>
);

// CarouselItem Component
const CarouselItem = ({ href, src, alt, caption, captionStyle, isActive }) => (
    <div className={`carousel-item ${isActive ? "active" : ""}`} style={{ cursor: "zoom-in" }}>
      <a href={href}>
        <img style={{ width: "1200px", height: "1200px" }} src={src} alt={alt} loading="lazy" />
      </a>
      <div className="carousel-caption d-none d-md-block">
        <h5 style={captionStyle}>{caption}</h5>
      </div>
    </div>
  );

// Carousel Component
const Carousel = ({ onChange }) => {
  const randomColor = useRandomColor();

  const carouselItems = [
    {
      href: "https://play.google.com/store/apps/details?id=com.jacobs.myapplication35",
      src: "01.jpg",
      alt: "First slide",
      caption: "Rhyme App:\nAndroid Studio, SQL",
      captionStyle: { color: "white", fontSize: "4rem", fontWeight: "bold" },
    },
    {
      href: "https://fashioned.herokuapp.com/",
      src: "/02.png",
      alt: "Second slide",
      caption: "Fashion E-commerce\nReact, Node, MongoDB",
      captionStyle: { color: "#500c77", fontSize: "4rem", fontWeight: "bold" },
    },
    {
      src: "/03.jpg",
      alt: "Third slide",
      caption: "Trading Bot for Crypto\nPython, Node, React\n(Under Construction...)",
      captionStyle: { color: "black", fontSize: "4rem", fontWeight: "bold" },
    },
    {
      href: "https://four-brick-airboat.glitch.me/",
      src: "/04.png",
      alt: "Fourth slide",
      caption: "Some More Stuff",
      captionStyle: { color: "black", fontSize: "4rem", fontWeight: "bold" },
    },
  ];

  return (
    <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel" style={{ width: "100%", height: "100%" }}>
      <ol className="carousel-indicators">
        {carouselItems.map((_, index) => (
          <CarouselIndicator key={index} index={index} isActive={index === 0} />
        ))}
      </ol>
      <div className="carousel-inner">
        {carouselItems.map((item, index) => (
          <CarouselItem key={index} {...item} isActive={index === 0} />
        ))}
      </div>
      <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" onClick={() => onChange(randomColor())}>
        <span className="carousel-control-prev-icon" style={{ width: "200px", height: "200px", backgroundColor: "black" }} aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" onClick={() => onChange(randomColor())}>
        <span className="carousel-control-next-icon" style={{ width: "200px", height: "200px", backgroundColor: "black" }} aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  );
};

export function VideoText({ ready, clicked, onChange, ...props }) {
  const mesh = useRef();

  return (
    <mesh {...props} ref={mesh}>
      <boxGeometry args={[2.7, 3, 0.9]} />
      <meshBasicMaterial toneMapped={false}>
        {ready ? (
          <Html className="content" position={[0, 0.4, -1.499]} transform occlude scale={[0.08, 0.08, 0.05]}>
            <Carousel onChange={onChange} />
          </Html>
        ) : null}
      </meshBasicMaterial>
    </mesh>
  );
}
